import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=1e44cb12&"
import script from "./Step5.vue?vue&type=script&lang=ts&"
export * from "./Step5.vue?vue&type=script&lang=ts&"
import style0 from "./Step5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports